// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5062":"e5fc220a","5568":"c561489e","9002":"c561489e","9063":"c561489e"}[chunkId] + ".chunk.css";
};